import React, { FC } from 'react';
import { CheckCircleIcon } from '@fronton/icons-react';
import { Icon, Snack } from 'fronton-react';
import { t } from 'i18next';

const DATA_QA_COPY_SKU_NOTIFICATION = 'copy-sku-notification';

type Props = {
  id: string;
};

export const CopySkuNotification: FC<Props> = ({ id }) => (
  <Snack
    key={id}
    id={id}
    data-qa={DATA_QA_COPY_SKU_NOTIFICATION}
    header={t('ui.snackbar.copy-sku-header')}
    icon={
      <Icon size={24}>
        <CheckCircleIcon />
      </Icon>
    }
    variant="neutral"
    autoHideTimer={1000}
  ></Snack>
);
